import {
	type InvestableUniverseSelectionStrategy,
	type InvestmentStatus,
	type PartialInvestableUniverseTicker,
	type UserInstrumentDto,
	ApplicationMode,
	ConstraintRelation,
} from "@eu.mdotm.api/sphere";
import type { Option } from "@mdotm/shadcn/legacy/components";
import { t } from "i18next";

type RelationOption = Option<ConstraintRelation>;
const relationOptions = [
	{ label: "Max", value: ConstraintRelation.Max },
	{ label: "Min", value: ConstraintRelation.Min },
	{ label: "Equal to", value: ConstraintRelation.Equal },
	{ label: "Between", value: ConstraintRelation.Between },
	{ label: "Exclude", value: ConstraintRelation.Exclude },
	{ label: "Relative to Reference", value: ConstraintRelation.RelativeToReference },
];

function excludeRelationOption(keys: ConstraintRelation[], opts: RelationOption[] = relationOptions): RelationOption[] {
	return opts.filter(({ value }) => keys.includes(value) === false);
}

const applicationModeOptions = [
	{
		label: "Portfolio exposure",
		value: ApplicationMode.PortfolioExposure,
	},
	{
		label: "Each instrument",
		value: ApplicationMode.EachInstrument,
	},
];

export function assocStatusToEntity(entityName?: string, status?: InvestmentStatus): string {
	return `${entityName ?? "-"} ${status && status !== "READY" ? `(${t(`PORTFOLIO_STATUS.${status}`)})` : ""}`;
}

/**
 * Moved there to avoid circular deps
 */
type InvestableUniverseInstrument = Omit<PartialInvestableUniverseTicker, "type"> &
	UserInstrumentDto & { strategy?: InvestableUniverseSelectionStrategy; additional?: boolean };

export {
	applicationModeOptions,
	excludeRelationOption,
	type RelationOption,
	relationOptions,
	type InvestableUniverseInstrument,
};
